export const START_UPDATE_APP_INFO = 'START_UPDATE_APP_INFO';
export const FINISH_UPDATE_APP_INFO = 'FINISH_UPDATE_APP_INFO';

export const UPDATE__USER__CONFIG__ENV___APP_INFO = 'UPDATE__USER__CONFIG__ENV___APP_INFO';
export const UPDATE__USER = 'UPDATE__USER';
